import { DataSignal } from 's-js';
import { Errors } from 'lib/validationWatcher';

import { UserSummary, UserSummaryData } from 'data/models/UserSummary';

export const VALIDATION_ALREADY_ACTIVE = 'AlreadyActive',
    VALIDATION_TOKEN = 'Token',
    VALIDATION_DEACTIVATED_ORG = 'DeactivatedOrganization',
    VALIDATION_DEACTIVATED_USER = 'DeactivatedUser';

// TH 12/15/2016 -- Common error handling functionality used by both
// AcceptInvitation and RestoreAccount pages.
export function HandleAlreadyActive(validationObj : Errors, user : DataSignal<UserSummary | null>) {
    if (validationObj[VALIDATION_ALREADY_ACTIVE]) {
        const userSummary = JSON.parse(validationObj[VALIDATION_ALREADY_ACTIVE].RawErrors[1]) as UserSummaryData;
        user(new UserSummary(userSummary));
    }
}


// WEBPACK FOOTER //
// ./apps/portcall/acceptinvitation/invitationerrors.ts